import {
  Dropdown,
  MenuButton,
  Menu,
  MenuItem,
  Typography,
  ListItemDecorator,
  ListDivider,
  ListItem,
  IconButton,
  Link,
  Button,
} from '@mui/joy';
import AppsIcon from '@mui/icons-material/Apps';
import type { ReactElement } from 'react';
import { useApplication, appConfigs, type App } from 'ApplicationContext';
import { useAuth } from 'components/management/NewAuthProvider';
import { getEnvConfig } from 'envConfig';

const AppSwitcher = (): ReactElement | null => {
  const { app, changeApplication } = useApplication();
  const { user, isAdmin } = useAuth();

  if (!user) {
    return null;
  }

  const availableApps = (Object.keys(appConfigs) as App[]).filter((appKey) => {
    const requiredGroups = appConfigs[appKey].cognitoGroups;
    return requiredGroups.some((group) => user.groups.includes(group)) || isAdmin;
  });

  const otherApps = availableApps.filter((appKey) => appKey !== app);
  if (otherApps.length <= 0) {
    return null;
  }

  return (
    <Dropdown>
      <MenuButton variant="soft" color="neutral" size="sm" slots={{ root: IconButton }}>
        <AppsIcon sx={{ fontSize: '1.2rem' }} />
      </MenuButton>
      <Menu
        placement="bottom-end"
        size="sm"
        sx={{
          minWidth: '200px',
        }}
      >
        <ListItem>
          <Typography level="title-sm" fontWeight="lg">
            Switch to application
          </Typography>
        </ListItem>
        <ListDivider />
        {otherApps.map((appKey) => {
          const currentAppConfig = appConfigs[appKey];
          const Logo = currentAppConfig.Logo;

          return (
            <MenuItem
              key={appKey}
              variant={'plain'}
              color={'neutral'}
              component={Link}
              sx={{
                textDecoration: 'none !important',
                paddingY: 0.5,
                paddingX: 1,
              }}
              {...changeApplication(appKey)}
            >
              <ListItemDecorator sx={{ width: '100%', paddingX: 1, paddingY: 0.7 }}>
                <Logo width="4rem" />
              </ListItemDecorator>
            </MenuItem>
          );
        })}
        <MenuItem sx={{ width: '100%', paddingX: 0, paddingY: 1 }}>
          <ListItemDecorator sx={{ width: '100%', paddingX: 1, paddingY: 0 }}>
            <Button
              variant="outlined"
              size="sm"
              sx={{ width: '100%' }}
              onClick={() => {
                window.location.href = `${getEnvConfig().externalAuthUrl}`;
              }}
            >
              All Apps
            </Button>
          </ListItemDecorator>
        </MenuItem>
      </Menu>
    </Dropdown>
  );
};

export default AppSwitcher;
